'use strict';

var $ = require('jquery');

/**
 * Chart Context Menu Directive
 * @constructor
 * @requires ChartDirective
 */
var FareChangeContextMenuDirective = function FareChangeContextMenuDirective($document) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/fare-change-context-menu.html'),
    scope: {
      menuItems: '=',
      snapshotDate: '=',
      runNumber: '=',
      allowAfterSnapshotDate: '='
    },
    link: function link(scope, element) {
      scope.selectedRow = undefined;
      scope.isAllowed = function () {
        if (!scope.allowAfterSnapshotDate) {
          return true;
        }
        return !scope.allowAfterSnapshotDate.isAfter(scope.snapshotDate);
      };
      var gridElement = element.parent().parent().find('.grid-body div').first();
      scope.triggerContextMenuAction = function () {
        if (!scope.isAllowed()) {
          return false;
        }
        var selectedItem = gridElement.jqxGrid('getrowdata', scope.selectedRow);
        if (selectedItem) {
          var beginDate = scope.snapshotDate;
          var endDate = beginDate.add(45, 'days').endOf('day');
          var eventData = {
            market: selectedItem.market,
            beginDate: beginDate,
            endDate: endDate,
            pos: selectedItem.pos,
            snapshotDate: scope.snapshotDate,
            runNumber: scope.runNumber,
            direction: selectedItem.direction,
            cabin: selectedItem.cabin
          };
          scope.$emit('context-menu:fare-change-grid', eventData);
        }
      };
      gridElement.on('contextmenu', function () {
        return false;
      });
      gridElement.on('cellclick', function (event) {
        if (event.args.rightclick) {
          var args = event.args;
          if (args.columnindex < 2) {
            scope.selectedRow = args.rowindex;
            element.css({
              display: 'block',
              left: parseInt(event.args.originalEvent.clientX) + 5 + $(window).scrollLeft(),
              top: parseInt(event.args.originalEvent.clientY) + 5 + $(window).scrollTop()
            });
          }
          return false;
        }
      });
      function hideOnWindowClick(event) {
        if ($(event.target).closest(element).length === 0) {
          element.hide();
          scope.$apply();
        }
      }
      $document.on('click', hideOnWindowClick);
      element.on('$destroy', function () {
        $document.off('click', hideOnWindowClick);
      });
    }
  };
};
FareChangeContextMenuDirective.$inject = ['$document'];
module.exports = FareChangeContextMenuDirective;